import ApiCrud from "./api-crud";

class CargoService extends ApiCrud {
  resource = "cargos";
  primaryKey = "idcargo";
}

export default new CargoService();
